import React, { createContext, useState, useContext } from 'react';

// 1. Context create karo
const BookingContext = createContext();

// 2. Provider create karo
export const BookingProvider = ({ children }) => {
  const [bookingWorker, setBookingWorker] = useState(null); // worker object store hoga

  return (
    <BookingContext.Provider value={{ bookingWorker, setBookingWorker }}>
      {children}
    </BookingContext.Provider>
  );
};

// 3. Custom hook for easy access
export const useBookingContext = () => useContext(BookingContext);